export const isDev =
  process.env.NODE_ENV === "development" ||
  window.location.origin.includes("vercel.app") ||
  window.location.origin.includes("//localhost:");

export const locale = isDev
  ? window?.location?.pathname?.replace("/", "") ?? "en_us"
  : window.Bose.DataLayer.Data.Page.formattedLocale;
